import * as React from "react"
import { batch } from "@preact/signals-react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate, getPreviousDate } from "@ui-seeker/utils"

import { SkuInfoBlock } from "@components"
import { DATE_PERIODS } from "@constants"
import { useBuildExternalURL } from "@hooks"
import { commonFiltersValue } from "@signals"
import { evolutionDataFilters, evolutionChartCurrentPeriod, shareOfSearchDetailsEndDate } from "../../../@signals"


export default function skuColumn() {
    return [{
        name: 'category', label: 'Category',
        options: {
            display: 'excluded'
        }
    }, {
        name: 'brand', label: 'Brand',
        options: {
            display: 'excluded'
        }
    }, {
		name:'ean', label: 'EAN',
		options: {
			display: 'excluded',
			filterType: 'textField'
		}
	}, {
        name: 'skuName', label: 'Product Name',
        options: {
			headerAlign: 'left',
            filterType: "textField",
            customBodyRowRenderLite: (value, { category, brand, ean, siteID, productID, keywordID, reference, productURL }) => {

				return <>
                <SkuInfoBlock 
                    sku={value} 
                    category={category} 
                    brand={brand} 
                    ean={ean}
                    reference={reference}
                    productURL={productURL} 
                />
                <ShowPositionCell 
                    keywordID={keywordID} 
                    productID={productID}  
                    siteID={siteID}
                />
                
            </>
			}
        }
    }]
}

const ShowPositionCell = ({ keywordID, productID, siteID }) => {
    const newFilters = commonFiltersValue.peek()

    const handleClick = () => { batch(() => {
        shareOfSearchDetailsEndDate.value = newFilters.endDate
        let startDate = formatDate(getPreviousDate({days: 6}, shareOfSearchDetailsEndDate.value), { format: FORMAT_DATE_BACK, receivedFormat: "%Y-%m-%dT%H:%M:%S.%LZ" })

        evolutionChartCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS

        evolutionDataFilters.value = {
            ...commonFiltersValue.peek(),
            startDate: startDate,
            endDate: shareOfSearchDetailsEndDate.value,
            keyword: [keywordID], 
            productID: productID,
            retailer: [siteID]
        }
    })}

    return <Box data-tour-trigger sx={{ display: 'flex', alignItems: 'flex-end'}} onClick={handleClick} >
        <Typography variant="caption" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5, cursor: 'pointer', "&:hover":{ textDecoration: 'underline'} }}>
            Show Position & Stock Evolution
        </Typography>
        <IconSeeker icon={'chart-line'} sx={{ mr: 0.5, margin: .5, color: 'primary.main'}}/>
    </Box>
}